const DB_NAME = 'offline_db';
const DB_VER = 1;
const STORE = 'pending_map_item_extra';

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VER);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        const os = db.createObjectStore(STORE, { keyPath: 'key' });
        os.createIndex('byRoundId', 'roundId', { unique: false });
        os.createIndex('byMapItemId', 'mapItemId', { unique: false });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function txDone(tx) {
  return new Promise((resolve, reject) => {
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
}

export async function upsertPendingMapItemExtra({ roundId, mapItemId, extra }) {
  const db = await openDb();
  const tx = db.transaction(STORE, 'readwrite');
  const store = tx.objectStore(STORE);

  const key = `${roundId}:${mapItemId}`;

  store.put({
    key,
    roundId,
    mapItemId,
    extra,
    updatedAt: Date.now(),
  });

  await txDone(tx);
  db.close();
  return key;
}

export async function getPendingMapItemExtra(roundId, mapItemId) {
  const db = await openDb();
  const tx = db.transaction(STORE, 'readonly');
  const store = tx.objectStore(STORE);
  const key = `${roundId}:${mapItemId}`;
  const req = store.get(key);

  const row = await new Promise((resolve, reject) => {
    req.onsuccess = () => resolve(req.result || null);
    req.onerror = () => reject(req.error);
  });

  await txDone(tx);
  db.close();
  return row;
}

export async function listPendingMapItemExtras(roundId) {
  const db = await openDb();
  const tx = db.transaction(STORE, 'readonly');
  const store = tx.objectStore(STORE);
  const idx = store.index('byRoundId');
  const req = idx.getAll(roundId);

  const rows = await new Promise((resolve, reject) => {
    req.onsuccess = () => resolve(req.result || []);
    req.onerror = () => reject(req.error);
  });

  await txDone(tx);
  db.close();

  rows.sort((a, b) => (a.updatedAt || 0) - (b.updatedAt || 0));
  return rows;
}

export async function removePendingMapItemExtra(roundId, mapItemId) {
  const db = await openDb();
  const tx = db.transaction(STORE, 'readwrite');
  const store = tx.objectStore(STORE);
  store.delete(`${roundId}:${mapItemId}`);
  await txDone(tx);
  db.close();
}


export async function clearPendingMapItemExtrasForRound(roundId) {
  const db = await openDb();
  const tx = db.transaction(STORE, 'readwrite');
  const store = tx.objectStore(STORE);
  const idx = store.index('byRoundId');

  const keysReq = idx.getAllKeys(roundId);
  const keys = await new Promise((resolve, reject) => {
    keysReq.onsuccess = () => resolve(keysReq.result || []);
    keysReq.onerror = () => reject(keysReq.error);
  });

  keys.forEach(k => store.delete(k));
  await txDone(tx);
  db.close();
}